/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ContainerState } from '../../models/container-state';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface StopContainer$Params {
  containerId: string;
}

export function stopContainer(
  http: HttpClient,
  rootUrl: string,
  params: StopContainer$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ContainerState>> {
  const rb = new RequestBuilder(rootUrl, stopContainer.PATH, 'post');
  if (params) {
    rb.path('containerId', params.containerId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContainerState>;
    }),
  );
}

stopContainer.PATH = '/manage/messaging/{containerId}/stop';
